// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardVerifyDto
 */
export interface ICardVerifyDto {
    /**
     * 
     * @type {string}
     * @memberof ICardVerifyDto
     */
    last4?: string;
}

/**
 * Check if a given object implements the ICardVerifyDto interface.
 */
export function instanceOfICardVerifyDto(value: object): value is ICardVerifyDto {
    return true;
}

export function ICardVerifyDtoFromJSON(json: any): ICardVerifyDto {
    return ICardVerifyDtoFromJSONTyped(json, false);
}

export function ICardVerifyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardVerifyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'last4': json['last4'] == null ? undefined : json['last4'],
    };
}

export function ICardVerifyDtoToJSON(json: any): ICardVerifyDto {
    return ICardVerifyDtoToJSONTyped(json, false);
}

export function ICardVerifyDtoToJSONTyped(value?: ICardVerifyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last4': value['last4'],
    };
}

